// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-pull[data-v-5caff866] {\n  position: fixed;\n  top: -48px;\n  width: 100%;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: top 0.7s ease-in-out;\n  z-index: 2;\n}\n.c-pull.c-visible[data-v-5caff866] {\n  top: 0px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
